<zwi-call-to-action>
  <ng-container title>
    <ng-content select="[title]"></ng-content>
  </ng-container>
  <ng-container content><ng-content select="[content]"></ng-content></ng-container>
  <button mat-flat-button color="primary" (click)="openSignIn()" action>Sign in</button>
</zwi-call-to-action>
<zwi-sign-in-dialog [open]="open" (closed)="close()"></zwi-sign-in-dialog>
